import { Map, List } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
export const actions = {
    REQUEST: createAction('ACCOUNTS/SEMANTIC_IDENTIFIERS/REQUEST'),
    SUCCESS: createAction('ACCOUNTS/SEMANTIC_IDENTIFIERS/SUCCESS'),
    ERROR: createAction('ACCOUNTS/SEMANTIC_IDENTIFIERS/ERROR'),
};
export const initialState = Map({
    data: List(),
    isProcessing: null,
    error: null,
});
const reducer = handleActions({
    [actions.REQUEST]: (state) => state.set('isProcessing', true).set('error', false),
    [actions.SUCCESS]: (state, action) => {
        return state
            .set('isProcessing', false)
            .set('error', false)
            .set('data', action.payload);
    },
    [actions.ERROR]: (state) => state.set('isProcessing', false).set('error', true),
}, initialState);
export default reducer;
